import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import ContactDetails from './ContactDetails.jsx';
import ChangePassword from './ChangePassword.jsx';
import PackagesComponent from './PackagesComponent.jsx';
import NotificationComponent from './NotificationComponent.jsx';
import MobileHeaderSearch from '../common/MobileHeaderSearch';
import ChangeTax from "./ChangeTax";

export default class UserAccounts extends Component {
  constructor(props) {
    super(props);
    this.changedOptions = this.changedOptions.bind(this);
    this.state = {
      vat: "",
      searchMobile: false,
      valueChanged: '1',
      showSidebar: false,
      authonticationValue: JSON.parse(localStorage.getItem('businessAuthData'))
    };
  }

  componentWillMount() {
    this.props.actions.getGarageInfo();
    this.props.actions.getBusinessTax();
  }
  componentWillReceiveProps(nextprops) {
    //  let taxInfo = nextprops.useraccountReducer.taxInfo;

  }


  componentWillUnmount() {
    //this.props.actions.hideErrorMessage();
  }

  toggleNotification(isVisible) {
    this.setState({ notificationVisible: isVisible });
  }

  toggleMessage(isVisible) {
    this.setState({ messageVisible: isVisible });
  }

  changedOptions(selectedata) {
    this.setState({ valueChanged: selectedata });
    //alert(selectedata);
  }
  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }
  render() {
    const { commonReducer, actions, router, authReducer, userReducer } = this.props;
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    return (
      <div>
        {/*Header*/}
        <Header
          searchMobile={this.state.searchMobile}
          hideOption={() => this.setState({ searchMobile: true })}
          commonReducer={this.props.commonReducer}
          actions={this.props.actions}
          notificationCount={2}
          profileName="Derrick Frank"
          noAutoSuggestCall="true"
          notificationCallBack={this.toggleNotification}
          authReducer={authReducer}
          hCallback={() => {
            this.hclickCallBack();
          }}
          router={this.props.router}
          isNewUser={
            authData &&
              authData.isBusinessRegistered &&
              authData.isGarageProfileCompleted &&
              authData.isGarageServiceSelected
              ? false
              : true
          }
        />
        <div className="main-wrapper">
          {/* <Sidebar
            showSidebar={this.state.showSidebar}
            router={router}
            actions={actions}
            commonReducer={commonReducer}
          /> */}
          <Sidebar
            showSidebar={this.state.showSidebar}
            router={this.props.router}
            actions={this.props.actions}
            commonReducer={this.props.commonReducer}
            authReducer={this.props.authReducer}
          />
          {/*<div className="container-fluid main-container container-center-setting">*/}
          <div className="container-fluid main-container">
            <div className="page-sec-header col">
              <div className="overview-heading accounts-overview-heading headrer-left-pod settings-header-mob">
                <h5>Settings</h5>
              </div>
              <div className="my-account-body my-account-body-mob-container">
                <div className="container-fluid navigation-header">
                  <div className="row clearfix">
                    <div
                      className={'col-sm-2 navigation-header-tab ' + (this.state.valueChanged === '1' ? 'active' : '')}
                      onClick={() => {
                        this.changedOptions('1');
                      }}
                    >
                      <span>ACCOUNT DETAILS</span>
                    </div>

                    {this.state.valueChanged === '1' &&
                      <div className="visible-xs mob-border">
                        <ContactDetails
                          authData={this.state.authonticationValue}
                          authReducer={this.props.authReducer}
                          commonReducer={this.props.commonReducer}
                          actions={this.props.actions}
                          router={this.props.router}
                          userReducer={this.props.useraccountReducer}
                        />
                      </div>
                    }
                    <div
                      className={'col-sm-2 navigation-header-tab ' + (this.state.valueChanged === '2' ? 'active' : '')}
                      onClick={() => {
                        this.changedOptions('2');
                      }}
                    >
                      <span>PAYMENT</span>
                    </div>

                    {this.state.valueChanged === '2' &&
                      <div className="visible-xs mob-border">
                        <ChangeTax userReducer={this.props.useraccountReducer} actions={this.props.actions} commonReducer={this.props.commonReducer}/>

                      </div>
                    }
                    <div
                      className={'col-sm-3 navigation-header-tab ' + (this.state.valueChanged === '3' ? 'active' : '')}
                      onClick={() => {
                        this.changedOptions('3');
                      }}
                    >
                      <span>CHANGE PASSWORD</span>
                    </div>

                    {this.state.valueChanged === '3' &&
                      <div className="visible-xs mob-border">
                        <ChangePassword authReducer={this.props.authReducer} actions={this.props.actions} />
                      </div>
                    }

                    <div
                      className={'col-sm-2 navigation-header-tab ' + (this.state.valueChanged === '4' ? 'active' : '')}
                      onClick={() => {
                        this.changedOptions('4');
                      }}
                    >
                      <span>PACKAGES</span>
                    </div>

                      {this.state.valueChanged === '4' &&
                        <div className="visible-xs mob-border">
                          <PackagesComponent actions={this.props.actions} />
                        </div>
                      }
                    <div
                      className={'col-sm-3 navigation-header-tab ' + (this.state.valueChanged === '5' ? 'active' : '')}
                      onClick={() => {
                        this.changedOptions('5');
                      }}
                    >
                      <span>NOTIFICATION</span>
                    </div>

                    {this.state.valueChanged === '5' &&
                      <div className="visible-xs mob-border">
                        <NotificationComponent
                          actions={this.props.actions}
                          authReducer={this.props.authReducer}
                          userReducer={this.props.useraccountReducer}
                        />
                      </div>
                    }

                  </div>
                </div>
                <div className="navigation-bady-part hidden-xs">
                  {this.state.valueChanged === '1' &&
                    <ContactDetails
                      authData={this.state.authonticationValue}
                      authReducer={this.props.authReducer}
                      commonReducer={this.props.commonReducer}
                      actions={this.props.actions}
                      router={this.props.router}
                      userReducer={this.props.useraccountReducer}
                    />}
                  {this.state.valueChanged === '2' &&
                    <ChangeTax userReducer={this.props.useraccountReducer} actions={this.props.actions} commonReducer={this.props.commonReducer}/>}
                  {this.state.valueChanged === '3' &&
                    <ChangePassword authReducer={this.props.authReducer} actions={this.props.actions} />}
                  {this.state.valueChanged === '4' && <PackagesComponent actions={this.props.actions} />}
                  {this.state.valueChanged === '5' &&
                    <NotificationComponent
                      actions={this.props.actions}
                      authReducer={this.props.authReducer}
                      userReducer={this.props.useraccountReducer}
                    />}
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.searchMobile &&
          <div>

            <MobileHeaderSearch
              mobile={true}
              actions={this.props.actions}
              commonReducer={this.props.commonReducer}
              mobSearchClick={() => this.setState({ searchMobile: false })}
            />
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserAccounts/userAccounts.jsx